import React, { useCallback, useContext } from "react";
import {
    CardWrapper,
    ColumnWrapper,
    PanelTitleWrapper,
    PanelContentWrapper,
    RequestInfoWrapper,
    RequestNumberWrapper,
    PurchaseOrderStatus,
    Label,
} from "./styled";
import { AppContext } from "hocs/withAppContext";
import { displayStatus } from "../consts";

function formatDate(dateObj) {
    var monthNames = [
        "January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"
    ];

    if (dateObj) {
        let date;
        if (dateObj.iso)
            date = new Date(dateObj.iso);
        else
            date = new Date(dateObj);
        return `${monthNames[date.getMonth()]} ${date.getDate()}, ${date.getUTCFullYear()}`;
    }
    else {
        return '-';
    }
}

const RequestCard = ({ request: req, onClick }) => {
    const { currencySymbol } = useContext(AppContext);
    const totalCost = `${currencySymbol} ${req.totalCost || 0}`;

    const handleOnClick = useCallback(() => {
        if (onClick) {
            onClick(req);
        }
    }, [onClick, req]);

    return <CardWrapper onClick={handleOnClick}>
        <PanelTitleWrapper>
            <PurchaseOrderStatus className={req.status}>
                <span className={`circle ${req.status}`}/>
                {displayStatus[req.status]}
            </PurchaseOrderStatus>
            <div>
                <Label><p>Requested by</p><span style={{'wordBreak': 'break-all'}}>{req.requesterEmail}</span></Label>
                <Label><p>Added On</p><span>{formatDate(req.createdAt)}</span></Label>
            </div>
        </PanelTitleWrapper>

        <PanelContentWrapper>
            <ColumnWrapper>
                <RequestNumberWrapper>
                    <Label>#{req.purchaseOrderNumber}</Label>
                </RequestNumberWrapper>
            </ColumnWrapper>
            <ColumnWrapper max="true">
                <RequestInfoWrapper>
                    <div>
                        <span>{req.title}</span>
                        <span>{(req.parts || []).length} Parts</span>
                    </div>
                    { req.dueDate && <div>
                        <span>Due Date</span>
                        <span>{formatDate(req.dueDate)}</span>
                    </div> }
                    { req.vendor && <div>
                        <span>Vendor</span>
                        <span>{req.vendor.businessName}</span>
                    </div> }

                    <div>
                        <span>Total Cost</span>
                        <span>{totalCost}</span>
                    </div>
                </RequestInfoWrapper>
            </ColumnWrapper>
        </PanelContentWrapper>
    </CardWrapper>
};


export default RequestCard;
